import { axiosInstance } from '.'
import {
  GET_WALLET_V1,
  WALLET_TOPUPS_V1,
  WALLET_TOPUP_V1,
  WALLET_WITHDRAWALS_V1,
  WALLET_WITHDRAWAL_V1,
} from './endpoints'

export type WalletLedgerFees = {
  platform_fee_cents: number
  bank_charges_cents: number
  fx_conversion_fee_cents: number
}

export type WalletLedgerEntry = {
  id: number
  type: string
  amount_cents: number
  balance_after_cents: number
  reference_type?: string | null
  reference_id?: string | null
  created_at: string
  metadata?: Record<string, unknown>
  opportunity_name?: string | null
  fees?: WalletLedgerFees
}

export type WalletTopup = {
  id: number
  amount_cents: number
  status: string
  order_id: string
  investment_id?: number | null
  metadata?: Record<string, unknown>
}

export type WalletSummary = {
  available: number
  pendingTopup: number
  pendingWithdraw: number
  investmentLimit: number
  totalInvestment: number
  canIntroduce: number
  maxInvestable: number
  reservedForInvestments?: number
  ledger: WalletLedgerEntry[]
  openTopups?: WalletTopup[]
}

export type WalletWithdrawal = {
  id: number
  amount_cents: number
  status: string
  order_id: string
  metadata?: Record<string, unknown>
}

const authHeaders = (headers: { [key: string]: string }) => ({ headers })

export const walletServices = {
  getWallet: async (headers: { [key: string]: string }) => {
    try {
      return await axiosInstance.get(GET_WALLET_V1, authHeaders(headers))
    } catch (error: any) {
      return error.response
    }
  },
  createTopup: async (
    payload: {
      amount: number
      investmentId?: number
      metadata?: Record<string, unknown>
    },
    headers: { [key: string]: string },
  ) => {
    try {
      return await axiosInstance.post(WALLET_TOPUPS_V1, payload, authHeaders(headers))
    } catch (error: any) {
      return error.response
    }
  },
  getTopup: async (id: number, headers: { [key: string]: string }) => {
    try {
      return await axiosInstance.get(WALLET_TOPUP_V1(id), authHeaders(headers))
    } catch (error: any) {
      return error.response
    }
  },
  patchTopup: async (
    id: number,
    payload: {
      status?: string
      amount?: number
      metadata?: Record<string, unknown>
    },
    headers: { [key: string]: string },
  ) => {
    try {
      return await axiosInstance.patch(WALLET_TOPUP_V1(id), payload, authHeaders(headers))
    } catch (error: any) {
      return error.response
    }
  },
  createWithdrawal: async (payload: { amount: number }, headers: { [key: string]: string }) => {
    try {
      return await axiosInstance.post(WALLET_WITHDRAWALS_V1, payload, authHeaders(headers))
    } catch (error: any) {
      return error.response
    }
  },
  patchWithdrawal: async (
    id: number,
    payload: { status?: string; metadata?: Record<string, unknown> },
    headers: { [key: string]: string },
  ) => {
    try {
      return await axiosInstance.patch(WALLET_WITHDRAWAL_V1(id), payload, authHeaders(headers))
    } catch (error: any) {
      return error.response
    }
  },
}
